(() => {
  const initPdp = (root) => {
    const menuToggle = root.querySelector('[data-menu-toggle]');
    const sideMenu = root.querySelector('[data-side-menu]');

    if (menuToggle && sideMenu) {
      menuToggle.addEventListener('click', () => {
        sideMenu.classList.toggle('active');
        menuToggle.classList.toggle('is-open', sideMenu.classList.contains('active'));
      });

      sideMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          sideMenu.classList.remove('active');
          menuToggle.classList.remove('is-open');
        });
      });
    }

    const track = root.querySelector('[data-carousel-track]');
    const prevBtn = root.querySelector('[data-carousel-prev]');
    const nextBtn = root.querySelector('[data-carousel-next]');
    const counter = root.querySelector('[data-slide-counter]');
    const thumbs = root.querySelectorAll('[data-thumb-index]');
    const dots = root.querySelectorAll('[data-dot-index]');
    const thumbStrip = root.querySelector('.loomforma-thumb-strip');

    if (track) {
      const total = Number(track.dataset.total || 0);
      let current = 0;
      let startX = 0;
      let isDragging = false;
      let hasInitialized = false;

      const setActive = () => {
        track.style.transform = `translateX(-${current * 100}%)`;
        if (counter) {
          counter.textContent = `${String(current + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
        }

        thumbs.forEach((thumb) => {
          thumb.classList.toggle('active', Number(thumb.dataset.thumbIndex) === current);
        });

        dots.forEach((dot) => {
          dot.classList.toggle('active', Number(dot.dataset.dotIndex) === current);
        });

        const activeThumb = root.querySelector(`[data-thumb-index='${current}']`);
        if (activeThumb && thumbStrip && hasInitialized) {
          const targetLeft = activeThumb.offsetLeft - (thumbStrip.clientWidth - activeThumb.clientWidth) / 2;

          thumbStrip.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth',
          });
        }

        hasInitialized = true;
      };

      const goTo = (idx) => {
        if (!total) return;
        current = (idx + total) % total;
        setActive();
      };

      prevBtn?.addEventListener('click', () => goTo(current - 1));
      nextBtn?.addEventListener('click', () => goTo(current + 1));

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => goTo(Number(thumb.dataset.thumbIndex)));
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(Number(dot.dataset.dotIndex)));
      });

      track.addEventListener(
        'touchstart',
        (event) => {
          startX = event.touches[0].clientX;
        },
        { passive: true },
      );

      track.addEventListener('touchend', (event) => {
        const diff = startX - event.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          goTo(diff > 0 ? current + 1 : current - 1);
        }
      });

      track.addEventListener('mousedown', (event) => {
        startX = event.clientX;
        isDragging = true;
      });

      track.addEventListener('mouseup', (event) => {
        if (!isDragging) return;
        isDragging = false;
        const diff = startX - event.clientX;
        if (Math.abs(diff) > 40) {
          goTo(diff > 0 ? current + 1 : current - 1);
        }
      });

      track.addEventListener('mouseleave', () => {
        isDragging = false;
      });

      setActive();
    }

    const mainPrice = root.querySelector('[data-main-price-text]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const formSubmit = root.querySelector('.loomforma-purchase-zone .product-form__submit');
    const stickyAtcButton = root.querySelector('[data-sticky-atc-btn]');
    const particle = root.querySelector('[data-atc-particle]');
    const cartLink =
      root.querySelector('[data-loomforma-cart-link]') || document.querySelector('[data-loomforma-cart-link]');
    const measurementToggle = root.querySelector('[data-measurement-toggle]');
    const measurementPanel = root.querySelector('[data-measurement-panel]');
    const measurementIcon = root.querySelector('[data-measurement-icon]');
    const measurementUnitButtons = root.querySelectorAll('[data-measurement-unit]');
    const measurementValues = root.querySelectorAll('.loomforma-measurement-value[data-cm]');
    const selectedVariantInput = root.querySelector('.product-variant-id');
    const measurementViewContainer = root.querySelector('[data-measurement-view-container]');
    const measurementSizeTabs = root.querySelectorAll('[data-measurement-size-tab]');
    const measurementDisplayValues = root.querySelectorAll('[data-measurement-display]');
    const measurementShowTableButton = root.querySelector('[data-measurement-show-table]');
    const measurementShowFocusButton = root.querySelector('[data-measurement-show-focus]');
    const relatedProducts = root.querySelector('[data-related-products]');
    const relatedProductsGrid = root.querySelector('[data-related-products-grid]');
    const variantInventoryDataNode = root.querySelector('[data-variant-inventory]');
    const preorderDescriptionSlot = root.querySelector('[data-preorder-description-slot]');
    const mainSubmitLabel = formSubmit ? formSubmit.querySelector('span:first-child') : null;
    let variantInventoryMap = new Map();

    const movePreorderDescription = () => {
      if (!preorderDescriptionSlot) return;

      const description = root.querySelector(
        '.restock-rocket-preorder-description:not([data-preorder-description-positioned])'
      );

      if (!description) return;

      description.dataset.preorderDescriptionPositioned = 'true';
      preorderDescriptionSlot.appendChild(description);
    };

    movePreorderDescription();

    if (preorderDescriptionSlot) {
      const preorderObserver = new MutationObserver(movePreorderDescription);
      preorderObserver.observe(root, { childList: true, subtree: true });
    }

    if (variantInventoryDataNode?.textContent) {
      try {
        const parsedInventory = JSON.parse(variantInventoryDataNode.textContent);
        if (Array.isArray(parsedInventory)) {
          variantInventoryMap = new Map(parsedInventory.map((variant) => [String(variant.id), variant]));
        }
      } catch (error) {
        console.error('Failed to parse variant inventory data', error);
      }
    }

    const extractDisplayPrice = () => {
      if (!mainPrice) return '';

      const preferredSelectors = [
        '.price__sale .price-item--last',
        '.price__sale .price-item--sale',
        '.price-item--last',
        '.price__regular .price-item--regular',
        '.price-item--regular',
      ];

      for (const selector of preferredSelectors) {
        const node = mainPrice.querySelector(selector);
        const text = node && node.textContent ? node.textContent.replace(/\s+/g, ' ').trim() : '';
        if (text) return text;
      }

      const fallbackText = mainPrice.textContent ? mainPrice.textContent.replace(/\s+/g, ' ').trim() : '';
      const matches = fallbackText.match(/(?:[$€£¥]|[A-Z]{3}\s?)?\d[\d,]*(?:\.\d{2})?(?:\s?[A-Z]{3})?/g);
      if (matches && matches.length) {
        return matches[matches.length - 1].trim();
      }

      return '';
    };

    const syncStickyPrice = () => {
      if (!mainPrice || !stickyPrice) return;
      const value = extractDisplayPrice();
      if (value) stickyPrice.textContent = value;
    };

    const getSelectedVariantInventory = () => {
      const selectedId = selectedVariantInput && selectedVariantInput.value ? String(selectedVariantInput.value) : '';
      return selectedId ? variantInventoryMap.get(selectedId) || null : null;
    };

    const isPreorderVariant = (selectedVariant) => {
      if (!selectedVariant) return false;

      return (
        selectedVariant.available &&
        selectedVariant.inventory_management === 'shopify' &&
        selectedVariant.inventory_policy === 'continue' &&
        Number(selectedVariant.inventory_quantity) <= 0
      );
    };

    const getAddToCartLabel = () => {
      const selectedVariant = getSelectedVariantInventory();
      if (isPreorderVariant(selectedVariant)) {
        return 'Pre-order';
      }

      if (
        selectedVariant &&
        selectedVariant.available &&
        selectedVariant.inventory_management === 'shopify'
      ) {
        const quantity = Number(selectedVariant.inventory_quantity);
        if (Number.isFinite(quantity) && quantity > 0 && quantity <= 5) {
          return `Only ${quantity} Left - Add To Cart`;
        }
      }

      return 'Add to Cart';
    };

    const syncStickyButton = () => {
      if (!formSubmit || !stickyAtcButton) return;
      if (formSubmit.classList.contains('is-added')) {
        stickyAtcButton.disabled = true;
        stickyAtcButton.classList.remove('is-loading');
        stickyAtcButton.classList.add('is-added');
        stickyAtcButton.textContent = 'Added';
        return;
      }

      const isLoading = formSubmit.classList.contains('loading');
      stickyAtcButton.classList.toggle('is-loading', isLoading);
      stickyAtcButton.classList.remove('is-added');
      const isSoldOut = formSubmit.disabled;
      const isTemporarilyDisabled = formSubmit.getAttribute('aria-disabled') === 'true';
      const pendingLabel = formSubmit.dataset.pendingLabel || '';
      const addToCartLabel = getAddToCartLabel();

      if (isLoading) {
        stickyAtcButton.disabled = true;
        stickyAtcButton.textContent = addToCartLabel;
        return;
      }

      if (isTemporarilyDisabled && pendingLabel) {
        stickyAtcButton.disabled = true;
        stickyAtcButton.textContent = pendingLabel;
        if (mainSubmitLabel) mainSubmitLabel.textContent = pendingLabel;
        return;
      }

      if (isSoldOut) {
        stickyAtcButton.disabled = true;
        stickyAtcButton.textContent = 'Sold Out';
        if (mainSubmitLabel) mainSubmitLabel.textContent = 'Sold Out';
        return;
      }

      stickyAtcButton.disabled = isTemporarilyDisabled;
      stickyAtcButton.textContent = addToCartLabel;
      if (mainSubmitLabel) mainSubmitLabel.textContent = addToCartLabel;
    };

    const animateParticleToCart = (triggerButton) => {
      if (!particle || !triggerButton || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!(triggerButton instanceof HTMLElement)) return;

      const startRect = triggerButton.getBoundingClientRect();
      const cartRect = (cartLink instanceof HTMLElement ? cartLink : null)?.getBoundingClientRect();

      const startX = startRect.left + startRect.width / 2;
      const startY = startRect.top + startRect.height / 2;
      const endX = cartRect ? cartRect.left + cartRect.width / 2 : window.innerWidth - 56;
      const endY = cartRect ? cartRect.top + cartRect.height / 2 : 56;
      const midX = (startX + endX) / 2;
      const midY = Math.min(startY, endY) - 80;

      particle.animate(
        [
          {
            opacity: 1,
            transform: `translate(${startX}px, ${startY}px) scale(1)`,
          },
          {
            opacity: 1,
            transform: `translate(${midX}px, ${midY}px) scale(1.15)`,
            offset: 0.5,
          },
          {
            opacity: 0,
            transform: `translate(${endX}px, ${endY}px) scale(0.2)`,
          },
        ],
        {
          duration: 700,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        },
      );
    };

    const pulseDrawer = () => {
      window.setTimeout(() => {
        const drawerInner = document.querySelector('cart-drawer .drawer__inner');
        if (!drawerInner) return;
        drawerInner.classList.remove('is-loomforma-added');
        void drawerInner.offsetWidth;
        drawerInner.classList.add('is-loomforma-added');
        window.setTimeout(() => {
          drawerInner.classList.remove('is-loomforma-added');
        }, 500);
      }, 60);
    };

    const formatMeasurement = (cmValue, unit, maxCmValue, isRange = false) => {
      const parse = (value) => {
        if (value == null || String(value).trim() === '') return null;
        const number = Number(value);
        return Number.isFinite(number) && number > 0 ? number : null;
      };
      const numeric = parse(cmValue);
      if (numeric === null) return '—';
      const format = (value) =>
        unit === 'in' ? (value / 2.54).toFixed(1) : value.toFixed(1).replace(/\.0$/, '');
      if (!isRange) return format(numeric);
      const maximum = parse(maxCmValue);
      // Do not turn an incomplete or reversed waist range into a valid size.
      if (maximum === null || maximum < numeric) return '—';
      return maximum === numeric ? format(numeric) : `${format(numeric)}\u2013${format(maximum)}`;
    };

    const formatRelatedPrice = (priceInCents, currencyCode) => {
      const numeric = Number(priceInCents);
      if (!Number.isFinite(numeric)) return '';

      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currencyCode || 'USD',
        }).format(numeric / 100);
      } catch (error) {
        return `${(numeric / 100).toFixed(2)} ${currencyCode || ''}`.trim();
      }
    };

    const escapeHtml = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const renderRelatedProducts = (products) => {
      if (!relatedProducts || !relatedProductsGrid || !products.length) {
        relatedProducts?.classList.remove('is-loaded');
        return;
      }

      const currencyCode = relatedProducts.dataset.relatedCurrency || 'AUD';

      relatedProductsGrid.innerHTML = products
        .slice(0, 4)
        .map((item) => {
          const featuredImage = item.featured_image;
          const fallbackImage = Array.isArray(item.images) ? item.images[0] : null;
          const image = featuredImage || fallbackImage;
          const imageUrl =
            typeof image === 'string'
              ? image
              : image?.url || image?.src || image?.featured_image?.url || image?.featured_image || '';
          const imageAlt = (typeof image === 'object' && (image.alt || image.alt_text)) || item.title;
          const imageWidth = (typeof image === 'object' && Number(image.width)) || 800;
          const imageHeight = (typeof image === 'object' && Number(image.height)) || 1000;

          const imageMarkup = imageUrl
            ? `<img
                src="${escapeHtml(imageUrl)}"
                alt="${escapeHtml(imageAlt || item.title)}"
                class="loomforma-product-image is-primary"
                loading="lazy"
                width="${imageWidth}"
                height="${imageHeight}"
              >`
            : '<div class="loomforma-product-image loomforma-product-image--placeholder"></div>';

          return `
            <div class="loomforma-related-products-item">
              <article class="loomforma-product-card">
                <a class="loomforma-product-link" href="${escapeHtml(item.url)}">
                  <div class="loomforma-product-image-container">
                    ${imageMarkup}
                  </div>
                  <div class="loomforma-product-meta">
                    <div>
                      <h3 class="loomforma-product-title">${escapeHtml(item.title)}</h3>
                      <p class="loomforma-product-price">${escapeHtml(formatRelatedPrice(item.price, currencyCode))}</p>
                      <span class="loomforma-dot-connector" aria-hidden="true"></span>
                    </div>
                  </div>
                </a>
              </article>
            </div>
          `;
        })
        .join('');

      relatedProducts.classList.add('is-loaded');
    };

    const loadRelatedProducts = () => {
      if (!relatedProducts || !relatedProductsGrid) return;

      const baseUrl = relatedProducts.dataset.relatedUrl;
      const productId = relatedProducts.dataset.relatedProductId;
      if (!baseUrl || !productId) return;

      const requestUrl = `${baseUrl}.json?product_id=${encodeURIComponent(productId)}&limit=4&intent=related`;

      fetch(requestUrl)
        .then((response) => {
          if (!response.ok) throw new Error(`Failed to load recommendations: ${response.status}`);
          return response.json();
        })
        .then((data) => {
          const products = Array.isArray(data?.products) ? data.products : [];
          renderRelatedProducts(products);
        })
        .catch((error) => {
          console.error(error);
          relatedProducts.classList.remove('is-loaded');
        });
    };

    let currentMeasurementUnit = 'cm';

    const syncMeasurementFocus = (activeTab) => {
      if (!activeTab || !measurementDisplayValues.length) return;

      measurementSizeTabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab === activeTab);
      });

      measurementDisplayValues.forEach((display) => {
        const key = display.dataset.measurementDisplay;
        const isRange = key === 'waist';
        const rawValue = isRange ? activeTab.dataset.waistMin : activeTab.dataset[key];
        display.style.opacity = '0';
        window.setTimeout(() => {
          display.textContent = formatMeasurement(rawValue, currentMeasurementUnit, activeTab.dataset.waistMax, isRange);
          display.style.opacity = '1';
        }, 90);
      });
    };

    const syncMeasurementFromSelectedVariant = () => {
      if (!measurementSizeTabs.length) return;

      const selectedId = selectedVariantInput && selectedVariantInput.value ? String(selectedVariantInput.value) : '';
      const activeTab =
        Array.from(measurementSizeTabs).find((tab) => tab.dataset.measurementVariant === selectedId) ||
        measurementSizeTabs[0];

      syncMeasurementFocus(activeTab);
    };

    if (measurementToggle && measurementPanel) {
      measurementToggle.addEventListener('click', () => {
        const isOpen = measurementPanel.classList.toggle('is-open');
        measurementToggle.setAttribute('aria-expanded', String(isOpen));
        if (measurementIcon) measurementIcon.textContent = isOpen ? '–' : '+';
      });
    }

    if (measurementUnitButtons.length && measurementValues.length) {
      measurementUnitButtons.forEach((button) => {
        button.addEventListener('click', () => {
          currentMeasurementUnit = button.dataset.measurementUnit || 'cm';

          measurementUnitButtons.forEach((item) => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', String(item === button));
          });

          measurementValues.forEach((value) => {
            const cmValue = value.dataset.cm;
            if (!cmValue) {
              value.textContent = '—';
              return;
            }

            value.style.opacity = '0';
            window.setTimeout(() => {
              value.textContent = formatMeasurement(
                cmValue,
                currentMeasurementUnit,
                value.dataset.cmMax,
                value.hasAttribute('data-cm-range'),
              );
              value.style.opacity = '1';
            }, 90);
          });

          const activeTab = Array.from(measurementSizeTabs).find((tab) => tab.classList.contains('is-active'));
          if (activeTab) syncMeasurementFocus(activeTab);
        });
      });
    }

    measurementSizeTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        syncMeasurementFocus(tab);
      });
    });

    measurementShowTableButton?.addEventListener('click', () => {
      measurementViewContainer?.setAttribute('data-mobile-view', 'table');
    });

    measurementShowFocusButton?.addEventListener('click', () => {
      measurementViewContainer?.setAttribute('data-mobile-view', 'focus');
    });

    syncMeasurementFromSelectedVariant();
    loadRelatedProducts();

    if (selectedVariantInput) {
      root.addEventListener('change', () => {
        window.setTimeout(() => {
          syncMeasurementFromSelectedVariant();
          syncStickyPrice();
          syncStickyButton();
        }, 0);
      });
    }

    syncStickyPrice();
    syncStickyButton();

    if (mainPrice) {
      const priceObserver = new MutationObserver(syncStickyPrice);
      priceObserver.observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }

    if (formSubmit) {
      const submitObserver = new MutationObserver(syncStickyButton);
      submitObserver.observe(formSubmit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
    }

    root.addEventListener('loomforma:add-success', (event) => {
      const detail = event.detail || {};
      if (detail.formId && root.querySelector(`form#${CSS.escape(detail.formId)}`) == null) return;
      animateParticleToCart(detail.triggerButton);
      pulseDrawer();
    });
  };

  document.querySelectorAll('[data-loomforma-pdp]').forEach(initPdp);
})();
